(function ($) {
  csPageSectionRowV1 = {
    formatter: $('.cs-page-section-row-v1')
  };

  Drupal.behaviors.csPageSectionRowV1 = {
    get: function (key) {
      return csPageSectionRowV1[key];
    },

    set: function (key, val) {
      csPageSectionRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var img = thisFormatter.find('.js-section-icon');

        img.each(function () {
          var $img = $(this);
          var tempImg = new Image();

          tempImg.onload = function () {
            $img.attr('width', this.width);
            $img.attr('height', this.height);
          };
          tempImg.src = $img.attr('src');
        });
      });
    }
  };
})(jQuery);
